/** Display-only fixtures for product tours - never persisted to the API/DB. */

const now = Date.now();
const hour = 60 * 60 * 1000;
const day = 24 * hour;

function isoIn(ms: number) {
  return new Date(now + ms).toISOString();
}

export const sampleUpcomingShifts = [
  {
    id: -9001,
    title: 'Morning reception',
    location: 'Main Office',
    start: isoIn(1 * day + 8 * hour),
    end: isoIn(1 * day + 14 * hour),
    filled: 2,
    capacity: 3,
  },
  {
    id: -9002,
    title: 'Evening support',
    location: 'Warehouse A',
    start: isoIn(2 * day + 16 * hour),
    end: isoIn(2 * day + 22 * hour),
    filled: 1,
    capacity: 2,
  },
  {
    id: -9003,
    title: 'Weekend event',
    location: 'Event Hall',
    start: isoIn(5 * day + 10 * hour),
    end: isoIn(5 * day + 18 * hour),
    filled: 4,
    capacity: 4,
  },
];

export const sampleRecentActivity = [
  {
    id: 'sample-job-app-1',
    type: 'job_application',
    title: 'New job application',
    description: 'Anna Novák applied for Receptionist',
    status: 'PENDING',
    date: isoIn(-3 * hour),
  },
  {
    id: 'sample-leave-1',
    type: 'shift_assignment',
    title: 'Leave request',
    description: 'Petr Svoboda requested to leave Evening support',
    status: 'PENDING',
    date: isoIn(-6 * hour),
  },
  {
    id: 'sample-assign-1',
    type: 'shift_assignment',
    title: 'Shift filled',
    description: 'Marie Dvořák signed up for Morning reception',
    status: 'CONFIRMED',
    date: isoIn(-12 * hour),
  },
];

export const sampleDashboardStats = {
  totalShifts: 12,
  activeEmployees: 8,
  totalWorkplaces: 3,
  fillRate: 78,
  totalUsers: 11,
  hoursThisMonth: 64,
  monthlyEarnings: '12 480 Kč',
};

export const sampleCreditBalance = {
  success: true,
  data: {
    balance: 42,
    isFreeTier: false,
    daysRemaining: 21,
  },
};

export const sampleEmployees = [
  {
    id: -9101,
    firstName: 'Anna',
    lastName: 'Novák',
    email: 'anna.demo@example.com',
    role: 'EMPLOYEE',
    avatarUrl: null,
    phone: '+420 777 111 222',
    active: true,
  },
  {
    id: -9102,
    firstName: 'Petr',
    lastName: 'Svoboda',
    email: 'petr.demo@example.com',
    role: 'EMPLOYEE',
    avatarUrl: null,
    phone: '+420 777 333 444',
    active: true,
  },
  {
    id: -9103,
    firstName: 'Marie',
    lastName: 'Dvořák',
    email: 'marie.demo@example.com',
    role: 'EMPLOYEE',
    avatarUrl: null,
    phone: null,
    active: true,
  },
];

export const sampleShiftsList = sampleUpcomingShifts.map((s) => ({
  ...s,
  status: s.filled! >= s.capacity! ? 'Full' : 'Open',
  payType: 'HOURLY',
  payRate: 180,
  assignments: Array.from({ length: s.filled || 0 }).map((_, i) => ({
    id: -(9200 + i),
    userId: -(9101 + i),
    status: 'CONFIRMED',
  })),
  workersNeeded: s.capacity,
  workersAssigned: s.filled,
}));

export const sampleMyShifts = [
  {
    id: -9001,
    title: 'Morning reception',
    location: 'Main Office',
    address: 'Náměstí 1, Praha',
    start: isoIn(1 * day + 8 * hour),
    end: isoIn(1 * day + 14 * hour),
    status: 'Upcoming',
    payType: 'HOURLY',
    payRate: 180,
    assignmentStatus: 'CONFIRMED',
  },
  {
    id: -9002,
    title: 'Evening support',
    location: 'Warehouse A',
    address: 'Průmyslová 12, Brno',
    start: isoIn(2 * day + 16 * hour),
    end: isoIn(2 * day + 22 * hour),
    status: 'Upcoming',
    payType: 'HOURLY',
    payRate: 200,
    assignmentStatus: 'CONFIRMED',
  },
];

export const sampleJobListings = [
  {
    id: -9301,
    title: 'Receptionist',
    description: 'Front-desk support for weekday mornings.',
    hourlyPayRate: 180,
    status: 'OPEN',
    applicationsCount: 3,
    workplace: { name: 'Main Office' },
  },
  {
    id: -9302,
    title: 'Warehouse helper',
    description: 'Evening packing and sorting.',
    hourlyPayRate: 200,
    status: 'OPEN',
    applicationsCount: 1,
    workplace: { name: 'Warehouse A' },
  },
];

export const sampleManagers = [
  {
    managerId: -9401,
    firstName: 'Jana',
    lastName: 'Králová',
    email: 'jana.demo@example.com',
    username: 'jana.k',
    active: true,
    avatarUrl: null,
    joinedAt: isoIn(-90 * day),
    workplaces: [{ name: 'Main Office' }, { name: 'Warehouse A' }],
  },
  {
    managerId: -9402,
    firstName: 'Tomáš',
    lastName: 'Horák',
    email: 'tomas.demo@example.com',
    username: 'tomas.h',
    active: true,
    avatarUrl: null,
    joinedAt: isoIn(-60 * day),
    workplaces: [{ name: 'Event Hall' }],
  },
];

export const sampleAttendanceRequests = [
  {
    id: -9501,
    status: 'PENDING',
    assignedAt: isoIn(-2 * hour),
    shift: {
      id: -9001,
      title: 'Morning reception',
      start: isoIn(1 * day + 8 * hour),
      end: isoIn(1 * day + 14 * hour),
      location: { id: -1, name: 'Main Office' },
    },
    employee: {
      id: -9101,
      username: 'anna.n',
      firstName: 'Anna',
      lastName: 'Novák',
      email: 'anna.demo@example.com',
    },
  },
];

export const sampleLeaveRequests = [
  {
    id: -9502,
    status: 'PENDING',
    requestedAt: isoIn(-5 * hour),
    reason: 'Family appointment',
    shift: {
      id: -9002,
      title: 'Evening support',
      start: isoIn(2 * day + 16 * hour),
      end: isoIn(2 * day + 22 * hour),
      location: { id: -2, name: 'Warehouse A' },
    },
    employee: {
      id: -9102,
      username: 'petr.s',
      firstName: 'Petr',
      lastName: 'Svoboda',
      email: 'petr.demo@example.com',
    },
  },
];

export const sampleVacationEntitlement = {
  year: new Date().getFullYear(),
  employmentType: 'HPP',
  eligible: true,
  entitlementHours: 160,
  usedHours: 24,
  remainingHours: 136,
  workedHours: 480,
  leaveWeeks: 4,
  reason: null,
};

export const sampleVacationRequests = [
  {
    id: -9601,
    startDate: isoIn(10 * day).slice(0, 10),
    endDate: isoIn(14 * day).slice(0, 10),
    hours: 40,
    status: 'PENDING',
    reason: 'Summer leave',
    responseReason: null,
    requestedAt: isoIn(-1 * day),
    user: { id: -9101, firstName: 'Anna', lastName: 'Novák', email: 'anna.demo@example.com' },
    contract: { id: -1, employmentType: 'HPP' },
  },
];

export const sampleWorkplaces = [
  {
    id: -9701,
    name: 'Main Office',
    address: JSON.stringify({
      country: 'CZ',
      region: 'Praha',
      city: 'Praha',
      zip: '11000',
      street: 'Náměstí 1',
    }),
    locationEmployees: [{}, {}],
  },
  {
    id: -9702,
    name: 'Warehouse A',
    address: JSON.stringify({
      country: 'CZ',
      region: 'Jihomoravský',
      city: 'Brno',
      zip: '60200',
      street: 'Průmyslová 12',
    }),
    locationEmployees: [{}],
  },
];

export const samplePositions = [
  { id: -9801, name: 'Receptionist', description: 'Front desk and guest support' },
  { id: -9802, name: 'Warehouse helper', description: 'Packing and sorting' },
];

export const sampleJobApplications = [
  {
    id: -9901,
    status: 'PENDING',
    createdAt: isoIn(-4 * hour),
    jobListing: {
      title: 'Receptionist',
      hourlyPayRate: 180,
      workplaceLocation: 'Main Office, Praha',
    },
    user: {
      id: -9101,
      firstName: 'Anna',
      lastName: 'Novák',
      email: 'anna.demo@example.com',
      phone: '+420 777 111 222',
      sex: null,
      cvFileUrl: null,
    },
  },
];

export const sampleContracts = [
  {
    id: -9910,
    status: 'SENT',
    sentAt: isoIn(-2 * day),
    duration: 'FIXED',
    employmentType: 'DPP',
    termKind: 'FIXED',
    customEndDate: isoIn(180 * day),
    contractFileUrl: null,
    signedFileUrl: null,
    location: { name: 'Main Office' },
    user: { id: -9101, firstName: 'Anna', lastName: 'Novák', email: 'anna.demo@example.com' },
  },
];
